/**
 * Created by guga on 7/21/2016.
 */
export class MenuConfigurationBean {
    public help : string; //IDENTIFIER OF THIS ITEM
    public icon:string;
    public noAvatar: boolean; //Item name;
    public noBag: boolean;
    public noCell:boolean //how many of this item is stacked
    public noCloseUsers:boolean
    public noEmoji:boolean 
    public noLeave:boolean 
    public noMap:string 
    public noMute:boolean 
    public noMyData:boolean 
    public noShare:boolean 
    public noStream:boolean 
    public noVideo:boolean 
    public noZoom:boolean 

    constructor (){
        this.help = ''; //IDENTIFIER OF THIS ITEM
        this.icon= ''; //IDENTIFIER OF THIS ITEM
        this.noAvatar= false; //Item name;
        this.noBag= false;
        this.noCell= false //how many of this item is stacked
        this.noCloseUsers= false
        this.noEmoji= false 
        this.noLeave= false 
        this.noMap= '' 
        this.noMute= false 
        this.noMyData= false 
        this.noShare= false 
        this.noStream= false 
        this.noVideo= false 
        this.noZoom= false 
    

    }
    
    public parse(val){
        if (!val) {val={}}
        this.help = val.help ? val.help : ''; //IDENTIFIER OF THIS ITEM
        this.icon= val.icon ? val.icon : ''; //IDENTIFIER OF THIS ITEM
        this.noAvatar= val.noAvatar ? val.noAvatar : false; //Item name;
        this.noBag= val.noBag ? val.noBag : false;
        this.noCell= val.noCell ? val.noCell : false //how many of this item is stacked
        this.noCloseUsers= val.noCloseUsers ? val.noCloseUsers : false
        this.noEmoji= val.noEmoji ? val.noEmoji : false 
        this.noLeave= val.noLeave ? val.noLeave : false 
        this.noMap= val.noMap ? val.noMap : '' 
        this.noMute= val.noMute ? val.noMute : false 
        this.noMyData= val.noMyData ? val.noMyData : false 
        this.noShare= val.noShare ? val.noShare : false 
        this.noStream= val.noSream ? val.noStream :  false 
        this.noVideo= val.noVideo ? val.noVideo : false 
        this.noZoom= val.noZoom ? val.noZoom : false 

    }
    public toDB() {
        let item= {

        }
        return item;
    }
};




// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/beansts/menu.configuration.bean.ts